import { render, staticRenderFns } from "./CampusGradeEdit.vue?vue&type=template&id=e81d6a72"
import script from "../../controllers/campus_grade/campus-grade-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/campus_grade/campus-grade-edit.js?vue&type=script&lang=js&external"
import style0 from "./CampusGradeEdit.vue?vue&type=style&index=0&id=e81d6a72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports